import { Card, CardActions, Typography, useTheme } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';

import { ALLOW_FOOD_MENU_PREFETCH } from '@/constants/prefetch';
import { FC } from 'react';

import Link from 'next/link';
import { pxToRem } from '@/theme/typography';
import ImageBoxFuture from '../shared/image-box-future';

interface FoodMenuProps {
  image: string;
  id: number;
  pdfLink: string;
}

export const FoodMenuCard: FC<FoodMenuProps> = ({ image, pdfLink }) => {
  const theme = useTheme();
  const intl = useIntl();

  return (
    <Card
      sx={{
        mb: { tablet: pxToRem(52), mobile: '24px' },
        background: theme.palette.layout.bgSecondary,
        boxShadow: theme.customShadows.cardShadow,
        borderRadius: '25px',
      }}
    >
      <ImageBoxFuture
        img={image}
        fallBackImg='/icons/foodMenu/food-menu-empty-state.svg'
        title={intl.formatMessage({
          id: 'alt.food_item',
        })}
        layout='intrinsic'
        objectFit='cover'
        width='524px'
        height='294px'
        sx={{
          borderRadius: '20px',
          overflow: 'hidden',
          marginBottom: {
            tablet: pxToRem(20),
            mobile: '24px',
          },
        }}
      />

      <CardActions
        sx={{
          justifyContent: 'center',
          mb: { tablet: pxToRem(20), mobile: '24px' },
          p: 0,
        }}
      >
        <Link
          href={{
            pathname: pdfLink,
          }}
          legacyBehavior
        passHref
          prefetch={ALLOW_FOOD_MENU_PREFETCH}
        >
          <Typography
            component='a'
            target='_blank'
            sx={{
              fontSize: '16px',
              width: '178px',
              height: '60px',
              borderRadius: '16px',
              backgroundColor: theme.palette.primary.main,
              color: theme.palette.common.white,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              textDecoration: 'none',
            }}
          >
            <FormattedMessage id='food_menu.view_menu' />
          </Typography>
        </Link>
      </CardActions>
    </Card>
  );
};

export default FoodMenuCard;
